import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles, Typography, Button,
} from '@material-ui/core';
import dayjs from 'dayjs';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { availabilitiesPeriod } from '../../config/config';
import {
  selectedClinicAvailabilitiesFilteredState,
  selectedTimeSlotState,
} from '../../state/selected';

const useStyles = makeStyles((theme) => ({
  dayHeaderText: {
    color: (props) => (props.dayDisabled
      ? theme.palette.text.disabled : theme.palette.text.primary),
  },
  dayHeader: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  btnHour: {
    minWidth: 0,
    paddingRight: 0,
    paddingLeft: 0,
    marginBottom: theme.spacing(1),
    color: theme.palette.common.white,
  },
}));

const sortSlotsByFromDate = (slot1, slot2) => {
  if (slot1.fromDayjs.isBefore(slot2.fromDayjs)) return -1;
  if (slot1.fromDayjs.isAfter(slot2.fromDayjs)) return 1;
  return 0;
};

const SchedulerDay = (props) => {
  const selectedClinicAvailabilitiesFiltered = useRecoilValue(
    selectedClinicAvailabilitiesFilteredState,
  );
  const setSelectedTimeSlot = useSetRecoilState(selectedTimeSlotState);

  const {
    day,
  } = props;

  const today = dayjs();
  const dayDisabled = today.isAfter(day, 'day') || today.add(availabilitiesPeriod.nb, availabilitiesPeriod.unit)
    .isBefore(day, 'day');

  const classes = useStyles({ dayDisabled });

  const formattedDay = day.format('YYYY-MM-DD');

  const slots = () => {
    const returnedSlots = selectedClinicAvailabilitiesFiltered
      .filter((a) => a.date === formattedDay)
      .reduce((acc, availability) => {
        const dureeMinutes = availability.dureeMinutesEval !== 0
          ? availability.dureeMinutesEval : availability.dureeMinutes;
        const from = dayjs(`${formattedDay} ${availability.from}`);
        const to = dayjs(`${formattedDay} ${availability.to}`);
        const nbSlots = Math.floor(to.diff(from, 'minute') / dureeMinutes);

        const returnedAcc = {
          ...acc,
        };

        Array(nbSlots)
          .fill(null)
          .map((s, i) => {
            const newSlotFromDayjs = from.add(dureeMinutes * i, 'minute');
            const newSlotFrom = newSlotFromDayjs.format('HH:mm');
            const match = returnedAcc.slots.filter((sl) => sl.from === newSlotFrom);

            const newSlot = {
              employeeID: availability.employeeID,
              from: newSlotFrom,
              fromDayjs: newSlotFromDayjs,
            };

            if (match && match.length > 0) {
              if (returnedAcc.employeeRankings[availability.employeeID]
                > returnedAcc.employeeRankings[match[0].employeeID]) {
                returnedAcc.slots = returnedAcc.slots.filter((sl) => sl.from !== newSlotFrom);
                returnedAcc.slots.push(newSlot);
              }
            } else {
              returnedAcc.slots.push(newSlot);
            }
            return null;
          });

        returnedAcc
          .employeeRankings[availability.employeeID] = (acc
            .employeeRankings[availability.employeeID] || 0) + nbSlots;

        return returnedAcc;
      }, {
        slots: [],
        employeeRankings: {},
      });

    returnedSlots.slots = returnedSlots.slots.sort(sortSlotsByFromDate);

    return returnedSlots;
  };

  return (
    <>
      <div className={classes.dayHeader}>
        <Typography
          variant="subtitle2"
          component="div"
          align="center"
          className={classes.dayHeaderText}
        >
          {day.format('dd')}
        </Typography>
        <Typography
          variant="subtitle2"
          component="div"
          align="center"
          className={classes.dayHeaderText}
        >
          {day.format('DD')}
        </Typography>
      </div>

      {selectedClinicAvailabilitiesFiltered
        && slots()
          .slots
          .map((slot) => (
            <Button
              className={classes.btnHour}
              size="small"
              variant="contained"
              color="primary"
              disableElevation
              fullWidth
              key={slot.from}
              onClick={() => {
                setSelectedTimeSlot(slot);
              }}
            >
              {slot.from}
            </Button>
          ))}
    </>
  );
};

SchedulerDay.propTypes = {
  day: PropTypes.shape({ format: PropTypes.func }).isRequired,
};

export default SchedulerDay;
